import api from '@/api'
import { Toast } from 'buefy'

export const setViewEntityType = ({ state, commit }, type) => {
  commit('SET_VIEW_ENTITY_TYPE', type)
}

export const doDelete = ({ state, commit }) => {
  commit('LOADING_START')
  return api.methods.deleteEntity(state.data)
    .then(() => {
      commit('SET_DATA', {})
      commit('SET_ID', null)
      commit('SET_VIEW_ENTITY_TYPE', null)
      commit('SET_SCHEMA', null)
      commit('LOADING_DONE')
    })
}

export const setResource = ({ state, commit }, { id, type, schema }) => {
  commit('LOADING_START')
  if (id != null) {
    commit('SET_ID', id)
  }
  if (schema != null) {
    commit('SET_SCHEMA', schema)
    commit('SET_VIEW_ENTITY_TYPE', type)
  }

  return api.methods.fetchResource(state.schema.className, state.id)
    .then((data) => {
      commit('SET_DATA', data)
      commit('LOADING_DONE')
    })
    .catch((error) => {
        // Error
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response)
        // this.$snackbar.open(`Default, positioned bottom-right with a green 'OK' button`)
        Toast.open({
          duration: 5000,
          message: `${state.schema.route} ${state.id}<br />
                    [${error.response.status}] ${error.response.statusText}`,
          position: 'is-bottom',
          type: 'is-carnelian'
        })
        commit('SET_DATA', null)
        commit('LOADING_DONE')
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
      console.log(error.config)
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/resource/actions.js